import React from 'react';
import './index.scss';
import dashboardImg from '../../resources/performanceAI/dashboard.svg';

// Import the new SVG icons
import actIcon from '../../resources/performanceAI/act.svg';
import connectIcon from '../../resources/performanceAI/connect.svg';
import growIcon from '../../resources/performanceAI/grow.svg';
import improveIcon from '../../resources/performanceAI/improve.svg';
import operationsIcon from '../../resources/performanceAI/operations.svg';
import predictIcon from '../../resources/performanceAI/predict.svg';
import releaseIcon from '../../resources/performanceAI/release.svg';

const PerformanceAI = () => {
	const handleDemoClick = () => {
		if (typeof document !== 'undefined') {
			window.location = '/contact';
		}
	};

	return (
		<div className='performance-ai-wrapper'>
			{/* ==========================================
			    SECTION 1: HERO
			========================================== */}
			<section className='hero-section'>
				<div className='hero-bg-shape'></div>
				<div className='container hero-container'>
					<div className='hero-content'>
						<h4 className='hero-subtitle'>PERFORMANCE.AI</h4>
						<h1 className='hero-title'>
							Turn Performance Gaps Into Measurable Business Impact
						</h1>
						<div className='hero-divider'></div>
						<p className='hero-description'>
							Performance.AI, powered by EPMTech, connects your enterprise data,
							AI, planning and execution to continuously improve revenue,
							margins, working capital and cash flow.
						</p>
						<button
							className='epm-hero__button epm-hero__button--primary'
							onClick={handleDemoClick}
							style={{ width: '152px' }}
						>
							Schedule a Demo
						</button>
					</div>
					<div className='hero-image-container'>
						<img
							className='dashboard-image'
							src={dashboardImg}
							alt='Performance.AI Dashboard'
						/>
					</div>
				</div>
			</section>

			{/* ==========================================
			    SECTION 2: HOW IT WORKS
			========================================== */}
			<section className='how-it-works-section'>
				<div className='container'>
					<div className='section-header'>
						<h2>How Performance.AI Works</h2>
						<p>
							Connect enterprise data, understand performance gaps, predict
							outcomes, and turn decisions into measurable impact.
						</p>
					</div>

					<div className='steps-container'>
						{/* Step 1 */}
						<div className='step-card'>
							<div className='step-icon-wrapper'>
								<img src={connectIcon} alt="Connect & Understand" className='custom-svg-icon' />
							</div>
							<h3>Connect & Understand</h3>
							<div className='step-text'>
								<span>Unify financial and operational data</span>
								<span>Surface deviations from plan</span>
								<span>Identify root causes across the business</span>
							</div>
						</div>

						<div className='step-arrow'>
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M5 12H19" stroke="#EC6927" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
								<path d="M12 5L19 12L12 19" stroke="#EC6927" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
						</div>

						{/* Step 2 */}
						<div className='step-card'>
							<div className='step-icon-wrapper'>
								<img src={predictIcon} alt="Predict & Optimize" className='custom-svg-icon' />
							</div>
							<h3>Predict & Optimize</h3>
							<div className='step-text'>
								<span>Forecast risks and opportunities</span>
								<span>Evaluate scenarios and trade-offs</span>
								<span>Prioritize actions by business impact</span>
							</div>
						</div>

						<div className='step-arrow'>
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M5 12H19" stroke="#EC6927" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
								<path d="M12 5L19 12L12 19" stroke="#EC6927" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
						</div>

						{/* Step 3 */}
						<div className='step-card'>
							<div className='step-icon-wrapper'>
								<img src={actIcon} alt="Act & Measure" className='custom-svg-icon' />
							</div>
							<h3>Act & Measure</h3>
							<div className='step-text'>
								<span>Recommend and assign interventions</span>
								<span>Track follow-up and accountability</span>
								<span>Measure realized EBITDA and cash-flow impact</span>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* ==========================================
			    SECTION 3: IMPACT
			========================================== */}
			<section className='impact-section'>
				<div className='container'>
					<div className='section-header dark-header'>
						<h2>Create Measurable Impact Across the Enterprise</h2>
						<p>
							Drive continuous improvement across the key levers of enterprise
							performance.
						</p>
					</div>

					<div className='impact-grid'>
						{/* Card 1 */}
						<div className='impact-card'>
							<div className='impact-icon-wrapper'>
								<img src={growIcon} alt="Grow Revenue" className='custom-svg-icon' />
							</div>
							<h3>Grow Revenue</h3>
							<p>Improve demand forecasting, sales performance, product mix and availability.</p>
						</div>

						{/* Card 2 */}
						<div className='impact-card'>
							<div className='impact-icon-wrapper'>
								<img src={improveIcon} alt="Improve Margin" className='custom-svg-icon' />
							</div>
							<h3>Improve Margin</h3>
							<p>Identify profitability gaps, cost variances and efficiency opportunities.</p>
						</div>

						{/* Card 3 */}
						<div className='impact-card'>
							<div className='impact-icon-wrapper'>
								<img src={releaseIcon} alt="Release Cash" className='custom-svg-icon' />
							</div>
							<h3>Release Cash</h3>
							<p>Optimize inventory, receivables and working capital.</p>
						</div>

						{/* Card 4 */}
						<div className='impact-card'>
							<div className='impact-icon-wrapper'>
								<img src={operationsIcon} alt="Improve Operations" className='custom-svg-icon' />
							</div>
							<h3>Improve Operations</h3>
							<p>Improve production, resource utilization, asset performance and project outcomes.</p>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
};

export default PerformanceAI;